// Portfolio Administration v1.0 PR 7 — HTTP transport for the metrics
// dashboard. Hooks in @/hooks/portfolioAdmin/usePr7 wrap these with
// TanStack Query. (The failure-tracking client retired with its page —
// the backend endpoints survive for manual edge cases via the API.)

import { api } from "../client";
import type {
  PortfolioCompositionMetrics,
  PortfolioFinancialMetrics,
  PortfolioOperationalHealthMetrics,
  PortfolioPerformanceMetrics,
} from "./pr7Types";

export const portfolioMetricsApi = {
  composition: () =>
    api.get<PortfolioCompositionMetrics>("/portfolio-admin/metrics/composition"),
  performance: () =>
    api.get<PortfolioPerformanceMetrics>("/portfolio-admin/metrics/performance"),
  operationalHealth: () =>
    api.get<PortfolioOperationalHealthMetrics>(
      "/portfolio-admin/metrics/operational-health",
    ),
  financial: () =>
    api.get<PortfolioFinancialMetrics>("/portfolio-admin/metrics/financial"),
  exportUrl: (format: "csv" = "csv") =>
    `/api/portfolio-admin/metrics/export?format=${format}`,
};
